import { useNavigate } from 'react-router-dom';
import useReveal from '@/hooks/useReveal';
import shared from '@/styles/public.module.css';
import styles from './PartnerDoorsSection.module.css';

const DOORS = [
  {
    eyebrow: 'For attorneys',
    title: 'Verify once, not five times',
    body: 'Confirm representation in a single portal, share documents securely, and stop fielding the same call from four funding companies about one client.',
    cta: 'Attorney portal',
    path: '/for-law-firms',
    testId: 'partner-door-attorneys',
  },
  {
    eyebrow: 'For funders',
    title: 'Attorney-verified deal flow',
    body: 'Review pre-screened cases with the documentation already attached, build offers with your own terms, and manage your portfolio in one place.',
    cta: 'Funder portal',
    path: '/for-funders',
    testId: 'partner-door-funders',
  },
];

const PartnerDoorsSection = () => {
  const navigate = useNavigate();
  const ref = useReveal(shared.rv, shared.revealed);

  return (
    <section
      className={`${shared.section} ${shared.sectionTight}`}
      ref={ref}
      data-testid="partner-doors-section"
    >
      <div className={`${shared.wrap} ${styles.doors}`}>
        {DOORS.map((door) => (
          <div key={door.path} className={`${styles.door} ${shared.rv}`}>
            <span className={shared.eyebrow}>{door.eyebrow}</span>
            <h3>{door.title}</h3>
            <p>{door.body}</p>
            <button
              type="button"
              className={`${shared.btn} ${shared.btnQuiet}`}
              onClick={() => navigate(door.path)}
              data-testid={door.testId}
            >
              {door.cta}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PartnerDoorsSection;
